// src/components/MainLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";

import EmployeeSidebar from "./EmployeeSidebar";
import Chatbot from "./Chatbot";

const MainLayout = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      
      {/* PERMANENT OUTLOOK-STYLE SIDEBAR */}
      <EmployeeSidebar />

      {/* CONTENT AREA (NO EXTRA MARGIN) */}
      <div className="flex-1 overflow-x-hidden">
        <main className="p-2">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Outlet />
          </motion.div>
        </main>

        <Chatbot />
      </div>
    </div>
  );
};

export default MainLayout;
